(function ($) {
    /**
     *  Collapse Navigation in mobile and not desktop
     */
    if ($(window).width() < 768) {
        $('#navbarNavDropdown').addClass('collapse');
    } else {
        $('#navbarNavDropdown').removeClass('collapse');
    }
    /**
     *  Focus content on site load
     */
    // $(document).ready(function() {
    //     $("#wrapper-navbar+.wrapper").focus();
    //     // $("#content").focus();
    // });
})(jQuery);
